import { render, staticRenderFns } from "./TechnicalReviewDashboard.vue?vue&type=template&id=1c87acf0&scoped=true"
import script from "./TechnicalReviewDashboard.vue?vue&type=script&lang=js"
export * from "./TechnicalReviewDashboard.vue?vue&type=script&lang=js"
import style0 from "./TechnicalReviewDashboard.vue?vue&type=style&index=0&id=1c87acf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87acf0",
  null
  
)

export default component.exports